<template>
  <CDropdown
    inNav
    placement="bottom-end"
    add-menu-classes="pt-0 pb-3 dropdown-menu dropdown-menu-lang text-hover"
    class="custom-nav-lang"
  >
    <template #toggler>
      <CHeaderNavLink
        style="display: flex; justify-content: center; align-items: center"
      >
        <img
          v-if="lang == 'TH'"
          class="icon-th"
          src="@/assets/icons/thailand.svg"
        />
        <img
          v-else-if="lang == 'EN'"
          class="icon-th"
          src="@/assets/icons/flag-usa.svg"
        />
        <img
          v-else-if="lang == 'CN'"
          class="icon-th"
          src="@/assets/icons/flag-chn.png"
        />
        <p class="mb-0 ml-1 icon-lang">{{ lang }}</p>
      </CHeaderNavLink>
    </template>

    <CDropdownHeader class="dropdown-header-lang"></CDropdownHeader>

    <CDropdownItem @click="funcChangeLanguage('th')">
      <CBadge>THAI</CBadge>
      <img
        style="width: 18px; hight: 18px"
        class="ml-auto mr-1 icon-right mt-1"
        src="@/assets/icons/thailand.svg"
      />
    </CDropdownItem>

    <CDropdownItem @click="funcChangeLanguage('en')">
      <CBadge>ENGLISH</CBadge>
      <img
        style="width: 20px; hight: 20px"
        class="ml-auto mr-1 icon-right mt-1"
        src="@/assets/icons/flag-usa.svg"
      />
    </CDropdownItem>
    <CDropdownItem @click="funcChangeLanguage('cn')">
      <CBadge>CHINESE</CBadge>
      <img
        style="width: 20px; hight: 20px"
        class="ml-auto mr-1 icon-right mt-1"
        src="@/assets/icons/flag-chn.png"
      />
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TheHeaderDropdownLang",
  data() {
    return {
      itemsCount: 42,
      lang: "TH",
    };
  },
  computed: {
    ...mapGetters({
      getLanguage: "language/getLanguage",
    }),
  },
  created() {},
  mounted() {
    this.lang = this.$store.getters["language/getLanguage"];
  },
  watch: {
    getLanguage: function (val) {
      this.lang = val;
    },
  },
  methods: {
    Getnoti() {
      this.$router.push("MainProfile");
    },
    funcChangeLanguage(val) {
      this.$store.dispatch("language/commitLanguage", val);
    },
  },
};
</script>


<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap");
.dropdown-menu-lang {
  border: 0px;
  border-radius: 15px;
  -webkit-box-shadow: 10px 15px 20px 1px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 10px 15px 20px 1px rgba(0, 0, 0, 0.5);
  box-shadow: 10px 15px 20px 1px rgba(0, 0, 0, 0.5);
}

.Customrow {
  margin-right: 1px;
  margin-left: -1px;
}

.custom-nav-lang {
  width: 70px;
  border: 1px solid lightgray;
  border-radius: 5px;
  display: grid;
}

.text-hover ::hover {
  color: red;
}

.dropdown-header-lang {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background-color: transparent;
  color: black;
  font-family: "Roboto";
  font-weight: 400;
  font-size: 16px;
  opacity: 95%;
}

.dropdown-item {
  font-family: "Roboto";
  font-weight: 500;
  font-size: 16px;
}
</style>

<style scoped>
.dropdown-menu {
  border-radius: 15px;
}

.dropdownfooter-ch1 {
  background-color: #cccc;
  height: 39px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.icon-right {
  float: right;
}

.dropdown-item:hover {
  /* background-color: #0080ff; */
  background-color: #ffa800;
  color: black !important;
  /* filter: invert(100%); */
}

a {
  color: inherit;
}

.icon-th {
  width: 22px;
}
.icon-lang {
  color: black;
  font-family: "Roboto";
  font-weight: 500;
}

@media only screen and (max-width: 200px) {
  .c-avatar {
    margin-left: 5em;
    margin-bottom: 5px;
    margin-left: 5px;
  }
}

@media only screen and (max-width: 415px) {
  .custom-nav-lang {
    margin-bottom: 5px;
    margin-left: 15px;
  }
}
</style>